import { ICellRendererParams } from "ag-grid-community";
import { classHOC } from "components/app/ClassWrapper";
import StatusChip, { StatusChipType } from "components/app/StatusChip";
import { useAxios } from "myAxios";
import { CSSProperties, FC } from "react";
import { toast } from "react-toastify";

const EscalationRenderer: FC<
  Partial<ICellRendererParams> & {
    valueCheck?: boolean;
    customStyle?: CSSProperties;
  }
> = ({ node, data, column, customStyle }) => {
  const axios = useAxios();
  const type = data?.escalationFlag ? (data?.escalationFlag === "Y" ? "Yes" : "No") : "No";

  const isOnlineAccount = data?.accountType === "Online";

  const editCallback = (value: StatusChipType) => {
    const flag = value === "Yes" ? "Y" : "N";
    axios
      .put(`/api/dataservice/v1/accounts/${data?.accountId}/escalations?escalation=${flag}`)
      .then((res) => {
        if (res.status === 200) {
          node?.setDataValue(column!, flag);
        }
      })
      .catch((e) => {
        toast.error(e?.response?.data?.message || "Failed to update Customer Escalation", {
          position: "top-center",
          autoClose: 3000,
        });
      });
  };

  if (node?.rowPinned) return null;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        height: "100%",
        ...customStyle,
      }}
    >
      {" "}
      {isOnlineAccount ? (
        "N/A"
      ) : (
        <StatusChip
          type={type}
          style={{ fontSize: 12 }}
          editProps={{
            options: ["Yes", "No"],
            editCallback,
          }}
        />
      )}
    </div>
  );
};

export default classHOC(EscalationRenderer);
